export const BookButtonWebHeight = "h-[52px]";
export const PaddingForBookButtonWeb = "pb-[52px]";

export const JpDayPreferenceOptions = [
  { label: "土・日・祝日希望", value: "2" },
  { label: "平日希望", value: "1" },
  { label: "具体的な日時を希望", value: "0" },
];

export const JpTimeOptions = [
  { label: "09:00-12:00", value: "1" },
  { label: "12:00-15:00", value: "2" },
  { label: "15:00-18:00", value: "3" },
  { label: "18:00以降", value: "4" },
];

export const JpSlotLabels = ["第1希望日時", "第2希望日時", "第3希望日時"];

export const DayOptions = [
  { label: "星期一", value: "MON" },
  { label: "星期二", value: "TUE" },
  { label: "星期三", value: "WED" },
  { label: "星期四", value: "THU" },
  { label: "星期五", value: "FRI" },
  { label: "星期六", value: "SAT" },
  { label: "星期日", value: "SUN" },
  { label: "公眾假期", value: "PUBLIC-HOLIDAY" },
];
